export default __webpack_public_path__ + "static/media/atm-limit.2bed10a8.svg";